import { LoanData } from '../types/loan'

export const initialLoanData: LoanData[] = [
  {
    id: '1',
    stage: 'Submitted',
    loanNumber: '1526070195',
    clientName: 'Aaron Adams',
    submittedDate: '02/28/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Mar 1, 2026 3:42 PM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$610,000',
    state: 'CA',
    lockStatus: '03/28/2026',
    cdStatus: 'Incomplete',
    remainingConditions: 4,
    appraisal: '02/20/2026',
    appraisalTransfer: 'N/A',
    payoff: '02/18/2026',
    hoi: 'Complete',
    title: '02/15/2026',
    pushList: false,
  },
  {
    id: '2',
    stage: 'Submitted',
    loanNumber: '1526104532',
    clientName: 'Abhi Sheth',
    submittedDate: '03/01/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Mar 2, 2026 10:15 AM',
    lender: 'UWM',
    loanType: 'Conv Cash Out',
    loanAmount: '$785,900',
    state: 'TX',
    lockStatus: 'Not Locked',
    cdStatus: 'Incomplete',
    remainingConditions: 7,
    appraisal: 'Not Requested',
    appraisalTransfer: 'N/A',
    payoff: '—',
    hoi: '02/25/2026',
    title: '02/22/2026',
    pushList: false,
  },
  {
    id: '3',
    stage: 'Submitted',
    loanNumber: '1226117334',
    clientName: 'Albert Paille',
    submittedDate: '02/25/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Bree Rueda',
    latestActivity: 'Feb 28, 2026 4:30 PM',
    lender: 'UWM',
    loanType: 'VA Cash Out',
    loanAmount: '$240,000',
    state: 'FL',
    lockStatus: '03/15/2026',
    cdStatus: 'Sent',
    remainingConditions: 2,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '4',
    stage: 'Suspended',
    loanNumber: '1525272432',
    clientName: 'Aleem Lalani',
    submittedDate: '02/20/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Gavin Fermanian',
    latestActivity: 'Feb 25, 2026 11:00 AM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$287,980',
    state: 'AZ',
    lockStatus: 'Not Locked',
    cdStatus: '—',
    remainingConditions: 12,
    appraisal: 'Not Requested',
    appraisalTransfer: 'N/A',
    payoff: '—',
    hoi: '—',
    title: '—',
    pushList: true,
  },
  {
    id: '5',
    stage: 'Suspended',
    loanNumber: '1226141717',
    clientName: 'Alex Tigner',
    submittedDate: '02/22/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Feb 26, 2026 9:20 AM',
    lender: 'UWM',
    loanType: 'FHA Streamline',
    loanAmount: '$368,843',
    state: 'NV',
    lockStatus: '03/10/2026',
    cdStatus: 'Incomplete',
    remainingConditions: 8,
    appraisal: '02/10/2026',
    appraisalTransfer: '02/12/2026',
    payoff: '—',
    hoi: '02/14/2026',
    title: '02/11/2026',
    pushList: true,
  },
  {
    id: '6',
    stage: 'AWC',
    loanNumber: '1526104844',
    clientName: 'Ashay Chourey',
    submittedDate: '02/27/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Mar 3, 2026 8:45 AM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$1,032,000',
    state: 'CA',
    lockStatus: '04/01/2026',
    cdStatus: 'Sent',
    remainingConditions: 3,
    appraisal: 'Complete',
    appraisalTransfer: 'N/A',
    payoff: '02/28/2026',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '7',
    stage: 'AWC',
    loanNumber: '1226119638',
    clientName: 'Bart Becker',
    submittedDate: '02/26/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Bree Rueda',
    latestActivity: 'Mar 2, 2026 1:30 PM',
    lender: 'UWM',
    loanType: 'FHA Streamline',
    loanAmount: '$306,695',
    state: 'OH',
    lockStatus: '03/20/2026',
    cdStatus: 'Incomplete',
    remainingConditions: 5,
    appraisal: '02/18/2026',
    appraisalTransfer: 'Complete',
    payoff: '—',
    hoi: '02/20/2026',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '8',
    stage: 'All In',
    loanNumber: '—',
    clientName: 'Beverly Rockwell',
    submittedDate: '02/15/2026',
    teamLeader: 'Jessica Torres',
    loa: '—',
    processor: 'Sydney Rasch',
    latestActivity: 'Feb 20, 2026 2:00 PM',
    lender: 'UWM',
    loanType: 'Conventional',
    loanAmount: '—',
    state: 'GA',
    lockStatus: 'Not Locked',
    cdStatus: '—',
    remainingConditions: '—',
    appraisal: 'Not Requested',
    appraisalTransfer: 'N/A',
    payoff: '—',
    hoi: '—',
    title: '—',
    pushList: true,
  },
  {
    id: '9',
    stage: 'All In',
    loanNumber: '1226115774',
    clientName: 'Bobby Daniel',
    submittedDate: '02/24/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Mar 1, 2026 11:45 AM',
    lender: 'UWM',
    loanType: 'VA IRRRL',
    loanAmount: '$339,857',
    state: 'VA',
    lockStatus: '03/25/2026',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '10',
    stage: 'CTC',
    loanNumber: '1226124667',
    clientName: 'Brandon Hess',
    submittedDate: '02/18/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Bree Rueda',
    latestActivity: 'Mar 3, 2026 9:00 AM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$50,000',
    state: 'MI',
    lockStatus: '04/05/2026',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '11',
    stage: 'CTC',
    loanNumber: '1525424785',
    clientName: 'Brandon Wlazelek',
    submittedDate: '02/20/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Kaelee Bierschbach',
    latestActivity: 'Mar 2, 2026 4:15 PM',
    lender: 'UWM',
    loanType: 'Conv Cash Out',
    loanAmount: '$429,500',
    state: 'WA',
    lockStatus: '04/02/2026',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'N/A',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '12',
    stage: 'Scheduled',
    loanNumber: '1226120065',
    clientName: 'Brannon Dunn',
    submittedDate: '02/17/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Bree Rueda',
    latestActivity: 'Mar 3, 2026 10:30 AM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$355,000',
    state: 'CO',
    lockStatus: '03/30/2026',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '13',
    stage: 'Scheduled',
    loanNumber: '1226123965',
    clientName: 'Brian Burger',
    submittedDate: '02/19/2026',
    teamLeader: 'Mike Chen',
    loa: 'Sarah Kim',
    processor: 'Bree Rueda',
    latestActivity: 'Mar 3, 2026 11:00 AM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$211,000',
    state: 'NC',
    lockStatus: '03/23/2026',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
  {
    id: '14',
    stage: 'Closed',
    loanNumber: '1525276275',
    clientName: 'Brian Hai Bui',
    submittedDate: '02/01/2026',
    teamLeader: 'Jessica Torres',
    loa: 'David Park',
    processor: 'Gavin Fermanian',
    latestActivity: 'Feb 15, 2026 3:00 PM',
    lender: 'UWM',
    loanType: 'Conv Rate/Term',
    loanAmount: '$554,500',
    state: 'OR',
    lockStatus: '—',
    cdStatus: 'Signed',
    remainingConditions: 0,
    appraisal: 'Complete',
    appraisalTransfer: 'Complete',
    payoff: 'Complete',
    hoi: 'Complete',
    title: 'Complete',
    pushList: false,
  },
]
